export default __webpack_public_path__ + "static/media/horseVET_logo.b10fa366.png";